<template>
    <tr :class="`${isEditRequested || isViewRequested ? 'hh-edit-row-one' : isDeleteRequested ? 'hh-delete-row' : ''}`">
        <td>{{ note.title }}</td>
        <td>{{ formatDate(note.date) }}</td>
        <td>{{ note.userName }}</td>
        <td class="text-end" v-if="!isDeleteRequested">
            <template v-if="note.isCreatedUser">
                <button
                    type="button"
                    class="btn table-btn btn-outline-info"
                    @click="openEditNote()"
                    v-if="!isEditRequested"
                    v-tooltip="{ title: 'Edit Note' }"
                >
                    <i class="fas fa-edit"></i>
                </button>
                <button
                    type="button"
                    class="btn table-btn btn-outline-danger"
                    @click="confirmDeleteNote()"
                    v-if="!isEditRequested"
                    v-tooltip="{ title: 'Delete Note' }"
                >
                    <i class="fas fa-trash-alt"></i>
                </button>
            </template>
            <template v-else>
                <button
                    type="button"
                    class="btn table-btn btn-outline-info"
                    @click="openViewNote()"
                    v-if="!isViewRequested"
                    v-tooltip="{ title: 'View Note' }"
                >
                    <i class="fas fa-eye"></i>
                </button>
            </template>
            <i v-if="isEditRequested">Edit In Progress</i>
            <i v-if="isViewRequested">View In Progress</i>
        </td>
        <td colspan="1" v-if="isDeleteRequested">
            <TablePrompt
                ok-text="delete"
                :is-in-progress="isDeleteInProgress"
                :ok="deleteNote"
                :cancel="cancelDeleteNote"
            />
        </td>
    </tr>
    <tr v-if="isEditRequested" class="hh-edit-row-two">
        <td :colspan="columns">
            <HHPreadmissionNotesForm
                :note="note"
                :referral-id="referralId"
                :show-note-form="isEditRequested"
                :reset-list="resetList"
                :referral="referral"
                :accountId="accountId"
                :application="application"
                :closeNoteForm="closeEditNote"
            />
        </td>
    </tr>
    <tr v-if="isViewRequested" class="hh-edit-row-two">
        <td :colspan="columns">
            <HHPreadmissionNotesForm
                :is-read-only="true"
                :show-note-form="isViewRequested"
                :note="note"
                :referral="referral"
                :closeNoteForm="closeViewNote"
            />
        </td>
    </tr>
</template>

<style src="./HHPreadmissionNotesRow.scss"></style>
<script lang="ts" src="./HHPreadmissionNotesRow.ts"></script>
